import { toast, ToastContent } from 'react-toastify';

const useToaster = () => {

  const info = (content: ToastContent) => {
    toast.info(content);
  };

  const success = (content: ToastContent) => {
    toast.success(content);
  };

  const warn = (content: ToastContent) => {
    toast.warn(content);
  };

  const danger = (content: ToastContent) => {
    toast.error(content, {
      autoClose: false,
    });
  };

  return {
    info,
    success,
    warn,
    danger,
  };

};

export default useToaster;
